/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import * as yup from 'yup';
import {ErrorMessage, Form, Formik} from 'formik';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import AppDialog from './AppDialog';
import TextField from '@material-ui/core/TextField';

import 'react-credit-cards/es/styles-compiled.css';

import AppButton from './AppButton';
import {useDispatch, useSelector} from 'react-redux';
import {addNotification, getAddresses, setLoadingCheckoutAddress} from '../redux/actions';

import api from '../services/api';
import {SELECTOR_USER} from '../redux/selectors/auth';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  title: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(2),
  },
  map: {
    height: 215,
    width: '100%',
    position: 'relative',
  },
  textField: {
    width: '100%',
  },
  formControl: {
    width: '100%',
  },
  textFieldStreet: {
    width: 150,
  },
}));

const validation = yup.object().shape({
  name: yup.string().max(256, 'Nombre es demasiado largo').required('Nombre es requerido.'),
  address: yup.string().max(256, 'Direccíon es demasiado largo').required('Direccíon es requerido.'),
  city: yup.string().max(256, 'Ciudad demasiado largo').required('Ciudad requerido.'),
  state: yup.string().max(256, 'Departamento es demasiado largo').required('Departamento es requerido.'),
});

const AddressDialog = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [currentState, setCurrentState] = useState(null);
  const [initialValues, setInitialValues] = useState({});
  const {currentEditAddress} = props;
  const currentUser = useSelector(SELECTOR_USER);

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    setInitialValues({
      city: currentEditAddress?.city?.name,
      state: currentEditAddress?.state?.name,
      address: currentEditAddress?.address,
      name: currentEditAddress?.name,
    });

    setCurrentState(currentEditAddress?.state?.name);
  }, [
    currentEditAddress?.name,
    currentEditAddress?.address,
    currentEditAddress?.city?.name,
    currentEditAddress?.state?.name,
  ]);

  useEffect(() => {
    // noinspection JSIgnoredPromiseFromCall
    fetchCities();
  }, [currentState]);

  const fetch = async () => {
    if (loadingStates) return;
    setLoadingStates(true);
    const {data} = await api.states.find({query: {$sort: {name: 1}}});
    setStates(data);
    setLoadingStates(false);
  };

  const fetchCities = async () => {
    if (loadingCities) return;
    setLoadingCities(true);
    let stateID = states.find((state) => state.name === currentState);
    const {data} = await api.cities.find({
      query: {state_id: stateID?.id, $sort: {name: 1}},
    });
    setCities(data);
    setLoadingCities(false);
  };

  const save = async ({name, address, state, city}) => {
    setLoading(true);
    let lat = null;
    let lng = null;
    try {
      let cityId = cities.find((item) => item.name === city);
      let stateId = states.find((item) => item.name === state);
      if (currentEditAddress.active) {
        await api.addresses.patch(currentEditAddress.id, {
          ...(currentEditAddress.integration_codigo_direccion
            ? {
                integration_codigo_direccion: currentEditAddress.integration_codigo_direccion,
              }
            : {}),
          ...(currentEditAddress.integration_nit
            ? {
                integration_nit: currentEditAddress.integration_nit,
              }
            : {}),
          city_id: cityId.id,
          state_id: stateId.id,
          user_id: currentUser.id,
          ...(lat ? {lat} : {}),
          ...(lng ? {lng} : {}),
          main: 'true',
          name,
          address,
        });
      } else {
        await api.addresses.create({
          ...(currentEditAddress.integration_codigo_direccion
            ? {
                integration_codigo_direccion: currentEditAddress.integration_codigo_direccion,
              }
            : {}),
          ...(currentEditAddress.integration_nit
            ? {
                integration_nit: currentEditAddress.integration_nit,
              }
            : {}),
          city_id: cityId.id,
          state_id: stateId.id,
          ...(lat ? {lat} : {}),
          ...(lng ? {lng} : {}),
          main: 'true',
          name,
          address,
        });
      }
      dispatch(getAddresses())
        .then(() => {
          dispatch(setLoadingCheckoutAddress(false));
        })
        .catch(() => {
          dispatch(setLoadingCheckoutAddress(false));
        });
      dispatch(addNotification('Dirección guardada', 'success'));
      props.handleClose();
    } catch (e) {
      dispatch(addNotification(e.message, 'error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppDialog maxWidth={800} {...props}>
      <DialogTitle id="alert-dialog-slide-title" className={classes.title}>
        {currentEditAddress.active ? 'Actualizar' : 'Agregar'} dirección
      </DialogTitle>
      <DialogContent>
        <Box mb={3} px={2} clone>
          <Formik
            initialValues={initialValues}
            validationSchema={validation}
            enableReinitialize
            onSubmit={save}
            render={({values, handleChange, handleSubmit, setFieldValue}) => (
              <Form
                onKeyPress={(event) => {
                  event.key === 'Enter' && handleSubmit();
                }}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <Box mb={2}>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <Typography variant="body2">Departamento</Typography>
                        <Select
                          labelId="state"
                          id="state"
                          name="state"
                          margin="dense"
                          className={classes.textField}
                          value={values.state}
                          onChange={(event) => {
                            setCurrentState(event.target.value);
                            setFieldValue('state', event.target.value);
                          }}
                        >
                          {states.map((state) => (
                            <MenuItem value={state.name} key={state.name}>
                              {state.name}
                            </MenuItem>
                          ))}
                        </Select>
                        <ErrorMessage
                          name="state"
                          render={(msg) => <div style={{color: 'red', fontWeight: 400}}>{msg}</div>}
                        />
                      </FormControl>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box mb={2}>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <Typography variant="body2">Ciudad</Typography>
                        <Select
                          labelId="city"
                          id="city"
                          name="city"
                          margin="dense"
                          className={classes.textField}
                          value={values.city}
                          onChange={handleChange}
                        >
                          {cities.map((city) => (
                            <MenuItem value={city.name} key={city.name}>
                              {city.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <ErrorMessage
                        name="city"
                        render={(msg) => <div style={{color: 'red', fontWeight: 400}}>{msg}</div>}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box mb={2}>
                      <Typography variant="body2">Dirección</Typography>
                      <TextField
                        variant="outlined"
                        placeHolder="CVV"
                        name="address"
                        value={values.address}
                        onChange={handleChange}
                        className={classes.textField}
                        margin="dense"
                      />
                      <ErrorMessage
                        name="address"
                        render={(msg) => <div style={{color: 'red', fontWeight: 400}}>{msg}</div>}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box mb={2}>
                      <Typography variant="body2">Nombre del punto</Typography>
                      <TextField
                        variant="outlined"
                        placeHolder=""
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        className={classes.textField}
                        margin="dense"
                      />
                      <ErrorMessage
                        name="name"
                        render={(msg) => <div style={{color: 'red', fontWeight: 400}}>{msg}</div>}
                      />
                    </Box>
                  </Grid>
                  <Box justifyContent="center" mt={3} display="flex" clone>
                    <Grid item xs={12}>
                      <AppButton
                        size="large"
                        onClick={handleSubmit}
                        loading={loading}
                        round
                        disableElevation
                        variant="contained"
                        color="secondary"
                      >
                        {currentEditAddress.active ? 'Actualizar' : 'Agregar'} dirección
                      </AppButton>
                    </Grid>
                  </Box>
                </Grid>
              </Form>
            )}
          />
        </Box>
      </DialogContent>
    </AppDialog>
  );
};

export default AddressDialog;
